import { Typography } from 'antd';
import { BlockProps } from 'antd/lib/typography/Base';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { DictionarySettingsStore } from 'stores/models/fieldsSettings';

const EDITABLE_CONFIG: BlockProps['editable'] = { triggerType: ['text'] };

const COPYABLE_CONFIG: BlockProps['copyable'] = {
  onCopy: () => null,
  tooltips: [null, null],
};

type Props = {
  store: DictionarySettingsStore;
};

const DictionaryHead: React.FC<Props> = ({ store }) => {
  return (
    <Typography.Title
      level={2}
      copyable={COPYABLE_CONFIG}
      editable={EDITABLE_CONFIG}
    >
      {store.dictionaryName}
    </Typography.Title>
  );
};

export default observer(DictionaryHead);
